$(document).ready(function () {
    const setSizes = function () {
        const isLarge = $.mediaQuery("lg");
        $(".tpl-slides").each(function () {
            const slides = $(this).find(".slide");
            const totalSlides = slides.length;
            $(this)
                .css("padding-bottom", isLarge ? 100 * totalSlides : "")
                .css("height", isLarge ? 800 * (totalSlides + 1) : "");

            $(this).find(".slide").removeClass("shown").removeClass("hidden");
        });
    };

    setSizes();
    $(window).on("resize", setSizes);

    $(window).on("scroll", function () {
        const scroll = $(window).scrollTop();
        const isLarge = $.mediaQuery("lg");

        $(".tpl-slides").each(function () {
            const wrapper = $(this).find(".wrapper");
            const top = $(this).offset().top - $.constants.menuHeight;
            const height =
                $(this).height() + parseInt($(this).css("padding-bottom"));
            const bottom = top + height + $.constants.menuHeight;
            const slides = $(this).find(".slide");

            if (scroll < top || scroll > bottom || !isLarge) {
                wrapper.css("top", "").toggleClass("fixed", false);
            } else {
                wrapper
                    .css("top", `${$.constants.menuHeight}px`)
                    .toggleClass("fixed", true);

                const slide = Math.min(
                    slides.length,
                    Math.floor((scroll - top) / 800) + 1
                );

                slides.each(function (index) {
                    $(this)
                        .toggleClass("shown", index < slide)
                        .toggleClass(
                            "hidden",
                            index + 1 != slide &&
                                index < slide &&
                                index < slides.length - 1
                        );
                });
            }
        });
    });
});
